import React, { createContext, useContext } from "react";
import { SegmentClient } from "@segment/analytics-react-native";

export const SegmentClientContext = createContext<SegmentClient | undefined>(
  undefined
);

export const useSegmentClient = () => useContext(SegmentClientContext);

export const SegmentClientProvider = ({
  client,
  children,
}: {
  client: SegmentClient;
  children: React.ReactNode;
}) => (
  <SegmentClientContext.Provider value={client}>
    {children}
  </SegmentClientContext.Provider>
);
